import React, { Component } from 'react'
import { decamelizeKeys } from 'humps'
import { connect } from 'react-redux'
import { Button } from 'reactstrap'
import styled from 'styled-components'

import { TitleScreen } from 'containers/ReceiptBooking/style'
import { startLoading, stopLoading, openError } from 'containers/App/reducers'

import Header from '../components/Header'
import SpFooter from '../components/SpFooter'
import { requestPost } from '../api'
import Storage from '../Storage'
import NotSupportedBrowser from 'components/NotSupportedBrowser'
import { isSp } from '../utils'
import theme from 'vars/theme'
import { SpFrame } from '../components/SpFrame'

export const Input = styled.input`
  border: 1px solid #ccc;
  border-radius: 4px;
  height: 52px;
  padding-left: 10px;
  padding-right: 10px;
`

class LoginPage extends Component {
  state = {
    password: '',
    errors: {},
    isSp: isSp(),
  }

  componentDidMount() {
    //   const { dispatchCheckinSessionLogout, dispatchCheckData, dispatchCheckIsLogginSession, match: { params } } = this.props
    //   const mid = _get(this, 'props.location.state.mid', '')
    //   // check is Loggin
    //   if (mid) dispatchCheckIsLogginSession(mid)
    //   if (_get(params, 'logout', '') === 'logout') {
    //     dispatchCheckinSessionLogout(params)
    //     return
    //   }
    //   dispatchCheckData({ warehouse_id: params.warehouseId, tenant_id: params.tenantId })
    window.addEventListener('resize', this.handleResize)
  }

  // UNSAFE_componentWillReceiveProps(nextProps) {
  //   if (!isEmpty(nextProps.errors)) {
  //     this.setState({
  //       errors: {
  //         message: nextProps.errors.message,
  //       },
  //     })
  //   }
  // }

  componentWillUnmount() {
    //   this.setState({
    //     password: '',
    //     errors: {},
    //   })
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize = () => {
    this.setState({ isSp: isSp() })
  }

  // handlePasswordChange = value => {
  //   this.setState(prevState => ({
  //     ...prevState,
  //     password: value,
  //   }))
  // }

  // handleLogin = () => {
  //   const { password } = this.state
  //   const warehouse_id = this.props.match.params.warehouseId
  //   const tenant_id = this.props.match.params.tenantId

  //   const { dispatchCheckinSessionLogin } = this.props

  //   if (password === '') {
  //     this.setState({
  //       errors: {
  //         message: errorMessages.Receipt.pleaseEnterPassword(),
  //       },
  //     })
  //   } else {
  //     this.setState({
  //       errors: {},
  //       password: '',
  //     }, () => dispatchCheckinSessionLogin({ warehouse_id, tenant_id, password }))
  //   }
  // }

  onChangePassword = (e) => {
    const { value } = e.target
    this.setState({ password: value })
  }

  onSubmitLogin = async (e) => {
    e.preventDefault()

    const referrer = this.props.location.state?.referrer
    if (!referrer) {
      this.props.openError('URLが正しくありません。正しいURLからアクセスしてください。', false)
      return
    }

    const { password } = this.state

    const matches = referrer.match(/[0-9]+/g)
    const [warehouseId, tenantId] = matches

    Storage.write('tenantId', tenantId)

    this.props.startLoading()

    try {
      await requestPost(
        '/tablets/sign_in',
        decamelizeKeys({
          warehouseId,
          tenantId,
          password,
        }),
        false
      )
    } catch (error) {
      this.props.openError(error.message, false)
      return
    } finally {
      this.props.stopLoading()
    }

    this.props.history.push(referrer)
  }

  render() {
    const { password, errors } = this.state

    if (errors.message === 'Data is empty') {
      return (
        <div>
          <div className="row justify-content-center">
            <TitleScreen>Page not found</TitleScreen>
          </div>
        </div>
      )
    }

    if (this.state.isSp) {
      return (
        <div style={{ backgroundColor: theme.graySoft6, height: '100vh', fontSize: 18 }}>
          <Header isSp />

          <div className="m-4">
            <SpFrame title="ログイン">
              <div className="mt-4">
                <h2
                  className="mb-5"
                  style={{
                    fontSize: 16,
                    lineHeight: 1.8,
                    color: theme.darkGrayPrimary,
                  }}
                >
                  パスワードを入力してログインしてください
                </h2>

                <form className="mt-0" onSubmit={this.onSubmitLogin}>
                  <Input
                    className="w-100 text-size24"
                    type="password"
                    value={password}
                    onChange={this.onChangePassword}
                  />
                </form>

                <div className="mt-5" style={{ marginBottom: 74 }}>
                  <Button
                    type="submit"
                    className="px-3 py-3 mx-auto d-block font-weight-bold rounded-pill w-100"
                    style={{ maxWidth: 300 }}
                    color="primary"
                    onClick={this.onSubmitLogin}
                  >
                    ログインする
                  </Button>
                </div>
              </div>
            </SpFrame>
          </div>
        </div>
      )
    }

    return (
      <div style={{ backgroundColor: '#EDEDED', height: '100vh', fontSize: 18 }}>
        <Header />
        <div style={{ margin: 32 }}>
          <NotSupportedBrowser />

          <div className="mb-3 p-5" style={{ borderRadius: 12, backgroundColor: 'white' }}>
            <div className="d-flex flex-column justify-content-center">
              <div className="row justify-content-center">
                <TitleScreen>ログイン</TitleScreen>
              </div>
              <div className="text-center mb-4">
                <p>パスワードを入力してログインしてください</p>
              </div>

              <form onSubmit={this.onSubmitLogin}>
                <div className="row justify-content-center mb-4">
                  <Input
                    // width="350px"
                    type="password"
                    value={password}
                    onChange={this.onChangePassword}
                    className="text-size24"
                    // errorMessage={errors.message}
                  />
                </div>
                <div className="row justify-content-center">
                  <Button
                    type="submit"
                    className="px-5 py-2 rounded-pill text-size24"
                    color="primary"
                  >
                    ログインする
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const reception = state.get('reception')
  return {
    multiTenants: reception.driver.multiTenants,
  }
}

const mapDispatchToProps = {
  openError,
  startLoading,
  stopLoading,
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage)
